import React, { useState, useEffect } from "react";
import {
  Platform,
  Picker,
  View,
  StyleSheet,
  TouchableOpacity,
  Text,
} from "react-native";

import { range } from "lodash";

import Utils from "../../../../helpers/utils";
import AppTheme from "../../AppTheme";

export default function TimePicker(props) {
  const { minutesInterval } = props;
  const [isStandardView, setIsStandardView] = useState(true);
  const [minutesItemsList, setMinutesItemsList] = useState([]);
  const [maxHours, setMaxHours] = useState(null);

  const [startTime, setStartTime] = useState({});
  const [endTime, setEndTime] = useState({});

  useEffect(() => {
    getMinutesItems();
  }, [isStandardView, endTime]);

  useEffect(() => {
    if (props.startTime) setStartTime(_parseTime(props.startTime));
    if (props.selectedTime) setEndTime(_parseTime(props.selectedTime));
  }, []);

  useEffect(() => {
    if (props.maxHours) setMaxHours(props.maxHours);
  }, [props.maxHours]);

  const _parseTime = (data) => {
    let time = {};
    const hours = data.split(":");
    time.hour = +hours[0];

    if (hours[1]) {
      const minutes_meridian = hours[1].split(" ");
      time.minutes = Utils.padDigits(minutes_meridian[0], 2);

      // Set meridian
      if (!props.has24Format && minutes_meridian[1]) {
        time.meridian = minutes_meridian[1];
      }
    }

    return time;
  };

  const _getMeridian = (selectedHour) => {
    const { hour, meridian } = startTime;

    return selectedHour == 12 ||
      (+hour < 12 && +hour >= 6 && +selectedHour < +hour)
      ? meridian == "PM"
        ? "AM"
        : "PM"
      : meridian || endTime.meridian;
  };

  const updateTime = (data) => {
    const { onChange } = props;
    const { hour, minutes, meridian } = endTime;

    let newTime = { hour, minutes, meridian };

    if (data.hour >= 0) {
      newTime.hour = data.hour;
      newTime.meridian = _getMeridian(data.hour);
    }
    if (data.minutes) newTime.minutes = data.minutes;
    if (data.meridian) newTime.meridian = data.meridian;

    setEndTime(newTime);
    const time = props.has24Format
      ? `${newTime.hour}:${newTime.minutes}`
      : `${newTime.hour}:${newTime.minutes} ${newTime.meridian}`;

    onChange(time);
  };

  const getHoursItems = () => {
    const { has24Format } = props;
    const hoursLimit = maxHours || (has24Format ? 24 : 12);

    return range(maxHours ? 0 : 1, hoursLimit + 1).map((h) => (
      <Picker.Item key={h} value={h} label={h.toString()} />
    ));
  };

  const getMinutesItems = () => {
    const forceAllMinutes =
      endTime.minutes != null && endTime.minutes % minutesInterval !== 0;
    let interval = Math.max(
      1,
      isStandardView && !forceAllMinutes ? minutesInterval || 15 : 1,
    );

    const items = Array.from(Array(Math.round(60 / interval))).map((_, i) => {
      const value = Utils.padDigits(i * interval, 2);
      return <Picker.Item key={i} value={value} label={value} />;
    });

    setMinutesItemsList(items);
  };

  const toggleAllTimeView = () => {
    setIsStandardView(!isStandardView);
  };
  return (
    <View style={styles.container}>
      {!props.noHeading ? (
        <TouchableOpacity
          onPress={toggleAllTimeView}
          style={styles.titleContainer}
        >
          <Text style={styles.title}>
            {isStandardView ? "Show All Times" : "Show Standard Intervals "}
          </Text>
        </TouchableOpacity>
      ) : null}

      <View style={styles.intervals}>
        <View style={styles.row}>
          {Platform.OS === "android" ? (
            <Text style={styles.label}>{endTime.hour}</Text>
          ) : null}
          <Picker
            style={styles.picker}
            selectedValue={endTime.hour}
            onValueChange={(h) => updateTime({ hour: h })}
          >
            {getHoursItems()}
          </Picker>
          {props.showLabels ? <Text style={styles.label}>hrs</Text> : null}
        </View>

        <View style={styles.row}>
          {Platform.OS === "android" ? (
            <Text style={styles.label}>{endTime.minutes}</Text>
          ) : null}
          <Picker
            style={styles.picker}
            selectedValue={endTime.minutes}
            onValueChange={(m) => updateTime({ minutes: m })}
          >
            {minutesItemsList}
          </Picker>
          {props.showLabels ? <Text style={styles.label}>min</Text> : null}
        </View>

        {!props.has24Format ? (
          <View style={styles.row}>
            {Platform.OS === "android" ? (
              <Text style={styles.label}>{endTime.meridian}</Text>
            ) : null}
            <Picker
              style={styles.picker}
              selectedValue={endTime.meridian}
              onValueChange={(m) => updateTime({ meridian: m })}
            >
              <Picker.Item key={0} value="AM" label="AM" />
              <Picker.Item key={1} value="PM" label="PM" />
            </Picker>
          </View>
        ) : null}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {},
  titleContainer: {
    marginTop: -35,
    marginHorizontal: -15,
    marginBottom: 20,
    paddingVertical: 14,
    borderBottomColor: "#F5F5F5",
    borderBottomWidth: 2,
  },
  title: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    textAlign: "center",
    color: AppTheme.DEFAULT_COLOR,
  },
  intervals: {
    flexDirection: "row",
    justifyContent: "space-evenly",
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
  },
  picker: {
    width: 60,
  },
  label: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#000",
    marginLeft: 5,
  },
});
